import {AppDispatch} from "../store"
import orderBookActionTypes from "../actionTypes/orderBook.actionTypes";
import { OrderBook } from "../proto/generated/security";

const dispatchOrderBook = (dispatch: AppDispatch, orderBook: OrderBook) => {
    dispatch({
        type: orderBookActionTypes.SET_ORDER_BOOK,
        payload: orderBook
    })
}

const orderBookActions = {
    dispatchOrderBook
}

export default orderBookActions